import * as React from 'react';

import { Utilities } from '../../../MedicareProAPI/Utilities/Utilities';
import { FileUpload } from '../../Components/Form/Field/FileUpload';
import type { FileUploadResponse } from '../../../MedicareProAPI/API/WebAPI';
import { WebAPI } from '../../../MedicareProAPI/API/WebAPI';
import { IndDocument } from '../../../MedicareProAPI/Entities/Ind/IndDocument';

export interface ManualProps {
  onChange: ({}) => void;
  formData: any;
  userId?: number;
  indId?: number;
  onDocUpload: (indId: number, attachment: any) => void;
}
/**
 * Component for filling out a manual form
 *
 * @author Andrew Brown <abrown@medicareprocrm.com>
 */
export const Manual = (props: ManualProps): React.JSX.Element => {
  const [docReferenceType, setDocReferenceType] = React.useState<number>(null);
  const [addingOtherType, setAddingOtherType] = React.useState<boolean>(false);
  const typeLegend = [
    { value: 0, label: 'Scope of Appointment' },
    { value: 1, label: 'Consumer Consent Form A' },
    { value: 2, label: 'Consumer Consent Form B' },
    { value: 3, label: 'Other' },
  ];

  const statusLegend = [
    { value: 'pending', label: 'Pending' },
    { value: 'completed', label: 'Completed' },
  ];

  /**
   * Handles a successful file upload by appending it to the attachments list,
   * updating the state, and triggering a save with the new attachment included.
   *
   * @param fileData - The uploaded file response containing metadata
   */
  const handleFileUpload = async (fileData: FileUploadResponse) => {
    const response = await props.onDocUpload(props.indId, fileData);
  };

  const handleFormTypeChange = (e) => {
    props.onChange(e);
    const value = e.target.value;

    if (value != 3) {
      setAddingOtherType(false);
    } else {
      setAddingOtherType(true);
    }
  };

  return (
    <>
      <div className="row gutter-2">
        <div className="col-12 p-2 font-weight-bold border-top border-info mt-3 mb-2 boldHeaderLabel">
          Details
        </div>

        <div className="col-12 col-lg-7 mb-2">
          <label className="label">Form Type</label>
          <select
            name="isConsent"
            onChange={handleFormTypeChange}
            className="form-control form-control-sm"
          >
            <option value="">Select...</option>
            {typeLegend.map((item, itemIndex) => {
              return <option value={item.value}>{item.label}</option>;
            })}
          </select>
        </div>
        <div className="col-12 col-lg-5 mb-2">
          <label className="label">Form Status</label>
          <select
            name="soaState"
            onChange={props.onChange}
            className="form-control form-control-sm"
          >
            <option value="">Select...</option>
            {statusLegend.map((item, itemIndex) => {
              return <option value={item.value}>{item.label}</option>;
            })}
          </select>
        </div>
        {addingOtherType && (
          <div className="col-12 col-lg-12 mb-2">
            <label className="label">Other form type</label>
            <input
              type="text"
              placeholder="POA, Medicaid, etc"
              className="form-control form-control-sm keep"
              name="otherDocName"
              value={props.formData.otherDocName}
              onChange={props.onChange}
            />
          </div>
        )}
        <div className="col-12 col-lg-6 mb-2">
          <label className="label">Date Created</label>
          <input
            type="date"
            className="keep form-control form-control-sm needsSlashes"
            name="soaCreatedDate"
            value={props.formData.soaCreatedDate}
            onChange={props.onChange}
            required
          />
        </div>
      </div>
      <div className="row gutter-2">
        <div className="col-12 p-2 font-weight-bold border-top border-info mt-3 mb-2 boldHeaderLabel">
          Document
        </div>

        <div className="col-12 col-lg-12 mb-2">
          <label className="label">Generated From</label>
          <input
            type="text"
            placeholder="Source of document (pdf, RetireFlo, Connecture, HealthSherpa, etc)"
            className="form-control form-control-sm keep"
            name="externalName"
            value={props.formData.externalName}
            onChange={props.onChange}
            required
          />
        </div>
        <div className="col-12 mb-2">
          <div className="badge cp badge-info mr-3" onClick={() => setDocReferenceType(1)}>
            <i className="far fa-plus-circle mr-1"></i>Add URL link to document
          </div>
          <FileUpload
            bucket="medicareprocrm"
            path={`documents`}
            extensions={['pdf']}
            autoUpload={true}
            onChange={handleFileUpload}
            reusable={true}
            fileUploadButtonLabel={'Upload PDF of Document'}
            selectButtonColor={'success'}
            uploadButtonColor={'success'}
            buttonStyle={'badge'}
            inline={true}
          />
        </div>

        {docReferenceType === 1 && (
          <div className="col-12 mb-2">
            <label className="label">Document URL</label>
            <input
              type="text"
              className="form-control form-control-sm keep"
              name="soaExternalSrc"
              value={props.formData.externalSrc}
              onChange={props.onChange}
              required
            />
          </div>
        )}
      </div>
    </>
  );
};
